import { gql } from "@apollo/client";

const CLIP_USER_FIELDS = gql`
  fragment ClipUserFragment on User {
    _id
    avatar
    avatarUrl
    commentsDisabled
    discord {
      id
      avatar
      username
    }
    rank
    userGroup {
      type
    }
    username
  }
`;

const MOMENT_TIMELINE_FIELDS = gql`
  fragment MomentTimelineFragment on Moment {
    title
    timelineLabel
    victimData {
      avatar
    }
    icons
    player {
      avatar
    }
  }
`;

export const GET_CLIP = gql`
  ${CLIP_USER_FIELDS}
  ${MOMENT_TIMELINE_FIELDS}

  query Clip(
    $id: String!
    $includeMomentTimeline: Boolean = false
    $includeBreakdown: Boolean = false
  ) {
    clip(id: $id) {
      id
      bytes
      canRequestPortrait
      createdAt
      game
      hasPortrait
      internalId
      isRemixable
      playerGameIdentifier
      pointOfView
      portraitUrl: url(orientation: PORTRAIT)
      shareId
      status
      tags {
        key
        value
      }
      thumbnailOverlayUrl: thumbnailUrl(style: OVERLAY)
      thumbnailStandardUrl: thumbnailUrl(style: STANDARD)
      title
      type
      url(orientation: LANDSCAPE)
      username
      views
      score
      scoreBreakdown @include(if: $includeBreakdown) {
        key
        value
        score
        percentTotal
      }
      useCase
      duration
      developer {
        id
        name
        slug
      }
      remixOf {
        user {
          avatar
          avatarUrl
          username
        }
      }
      campaign {
        isActive
        marketing {
          backgroundImage
          brandLogo
          copyClip
        }
        primaryColor
        secondaryColor
        slug
        endsAt
      }

      effects {
        id
        internalId
        title
        types
      }

      moment {
        id
        ...MomentTimelineFragment @include(if: $includeMomentTimeline)
        match {
          id
          players {
            accountName
            avatar
            displayName
            gameId
            user {
              ...ClipUserFragment @nonreactive
            }
          }
        }
      }

      reactions {
        count
        type
      }

      user {
        ...ClipUserFragment @nonreactive
      }

      associatedUsers {
        internalId
        username
        rank
        avatar
        userGroup {
          type
        }
      }

      saved {
        savedBy
      }

      expires {
        expiresAt
        reason
      }

      clipQualityConfig {
        frameBlendBlur
        framerate
        resolution
      }
    }
  }
`;
